import React from 'react';
import PropTypes from 'prop-types';
import ReactMarkdown from 'react-markdown';
import { Link } from 'gatsby-plugin-intl';

import * as styles from './markdown.module.scss';

type MarkdownProps = {
  children: string;
  openLinksInNewTab?: boolean;
  className?: string;
};

const Markdown = ({ children, openLinksInNewTab, ...props }: MarkdownProps) => {
  const target = openLinksInNewTab ? '_blank' : undefined;
  const linkFormatter = ({ href, title, children }) => {
    const char = href.charAt(0);
    if (
      !openLinksInNewTab &&
      (char === '.' || (char === '/' && !href.endsWith('.pdf')))
    ) {
      return (
        <Link to={href} title={title}>
          {children}
        </Link>
      );
    } else {
      return (
        <a href={href} title={title} target={target}>
          {children}
        </a>
      );
    }
  };

  return (
    <ReactMarkdown
      className={styles.markdown}
      linkTarget="_blank"
      components={{
        a: linkFormatter,
      }}
      {...props}
    >
      {children}
    </ReactMarkdown>
  );
};

Markdown.propTypes = {
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
  openLinksInNewTab: PropTypes.bool,
};

export default Markdown;
